import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon/Icon'
import LanguageSwitcher from './LanguageSwitcher'
import ModalButton from './ModalButton'

import './components.css'

const Nav = () => {
  return (
    <div className='nav_container'>
      <div className="nav_item">
        <Link to='/' className='logo'><img src={Icon.logo} alt="Logo" /></Link>
        <div className="nav_panel">
          <div className="nav_link">
            <Link to='/'>HOME</Link>
            <Link to='/about'>ABOUT</Link>
            <Link to='/team'>TEAM</Link>
            <Link to='/services'>SERVICES</Link>
            <Link to='/how-its-work'>HOW IT WORKS</Link>
            <Link to='/blog'>BLOG</Link>
            <LanguageSwitcher />
          </div>
          <ModalButton />
          <button className="lang_btn-mobile"><LanguageSwitcher /></button>
          <Link to='/contact' className='contact_link'>CONTACT <img src={Icon.mailIcon} alt="contact" /></Link>
        </div>
      </div>
    </div>
  );
};

export default Nav;